// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/components/layout/Navbar.css */
.navbar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  padding: 20px 0;
  transition: var(--transition-smooth);
}

.navbar-scrolled {
  padding: 15px 0;
  background: rgba(10, 10, 10, 0.95);
  backdrop-filter: blur(10px);
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.5);
}

.navbar-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.navbar-brand {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 1.5rem;
  font-weight: 800;
  cursor: pointer;
  transition: var(--transition-smooth);
}

.navbar-brand:hover {
  transform: scale(1.05);
}

.logo-text {
  letter-spacing: 2px;
}

.navbar-menu {
  display: flex;
  gap: 40px;
  align-items: center;
}

.nav-link {
  color: var(--text-primary);
  text-decoration: none;
  font-weight: 500;
  position: relative;
  transition: var(--transition-smooth);
  padding: 5px 0;
}

.nav-link::after {
  content: '';
  position: absolute;
  bottom: -5px;
  left: 0;
  width: 0;
  height: 2px;
  background: var(--gradient-primary);
  transition: width 0.3s ease;
}

.nav-link:hover::after {
  width: 100%;
}

.nav-link:hover {
  color: var(--primary-color);
}

.navbar-actions {
  display: flex;
  align-items: center;
  gap: 20px;
}

.language-selector {
  position: relative;
}

.lang-button {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 25px;
  color: var(--text-primary);
  cursor: pointer;
  transition: var(--transition-smooth);
}

.lang-button:hover {
  background: rgba(255, 255, 255, 0.15);
  border-color: var(--primary-color);
}

.current-lang {
  font-size: 1.2rem;
}

.lang-dropdown {
  position: absolute;
  top: calc(100% + 10px);
  right: 0;
  background: var(--dark-secondary);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 15px;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.5);
  animation: fadeIn 0.3s ease;
}

.lang-option {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 20px;
  background: transparent;
  border: none;
  color: var(--text-primary);
  cursor: pointer;
  width: 100%;
  text-align: left;
  transition: var(--transition-smooth);
}

.lang-option:hover {
  background: rgba(255, 255, 255, 0.1);
}

.lang-option.active {
  background: var(--gradient-primary);
  color: var(--dark-bg);
}

.lang-flag {
  font-size: 1.2rem;
}

.menu-toggle {
  display: none;
  background: transparent;
  border: none;
  color: var(--text-primary);
  cursor: pointer;
  padding: 8px;
  transition: var(--transition-smooth);
}

.menu-toggle:hover {
  color: var(--primary-color);
}

/* Mobile Styles */
@media (max-width: 768px) {
  .navbar-menu {
    position: fixed;
    top: 0;
    right: -100%;
    width: 80%;
    max-width: 300px;
    height: 100vh;
    background: var(--dark-secondary);
    flex-direction: column;
    justify-content: center;
    gap: 30px;
    transition: right 0.3s ease;
    box-shadow: -5px 0 20px rgba(0, 0, 0, 0.5);
  }

  .navbar-menu.active {
    right: 0;
  }

  .menu-toggle {
    display: block;
  }

  .nav-link {
    font-size: 1.2rem;
  }

  .navbar-brand {
    font-size: 1.2rem;
  }

  .lang-dropdown {
    right: -50px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/layout/Navbar.css"],"names":[],"mappings":"AAAA,qCAAqC;AACrC;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,aAAa;EACb,eAAe;EACf,oCAAoC;AACtC;;AAEA;EACE,eAAe;EACf,kCAAkC;EAClC,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,oCAAoC;AACtC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,QAAQ;EACR,WAAW;EACX,mCAAmC;EACnC,2BAA2B;AAC7B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,oCAAoC;EACpC,0CAA0C;EAC1C,mBAAmB;EACnB,0BAA0B;EAC1B,eAAe;EACf,oCAAoC;AACtC;;AAEA;EACE,qCAAqC;EACrC,kCAAkC;AACpC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,QAAQ;EACR,iCAAiC;EACjC,0CAA0C;EAC1C,mBAAmB;EACnB,gBAAgB;EAChB,0CAA0C;EAC1C,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,YAAY;EACZ,0BAA0B;EAC1B,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,mCAAmC;EACnC,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,0BAA0B;EAC1B,eAAe;EACf,YAAY;EACZ,oCAAoC;AACtC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,kBAAkB;AAClB;EACE;IACE,eAAe;IACf,MAAM;IACN,YAAY;IACZ,UAAU;IACV,gBAAgB;IAChB,aAAa;IACb,iCAAiC;IACjC,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;IACT,2BAA2B;IAC3B,0CAA0C;EAC5C;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,YAAY;EACd;AACF","sourcesContent":["/* src/components/layout/Navbar.css */\n.navbar {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  z-index: 1000;\n  padding: 20px 0;\n  transition: var(--transition-smooth);\n}\n\n.navbar-scrolled {\n  padding: 15px 0;\n  background: rgba(10, 10, 10, 0.95);\n  backdrop-filter: blur(10px);\n  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.5);\n}\n\n.navbar-container {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.navbar-brand {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  font-size: 1.5rem;\n  font-weight: 800;\n  cursor: pointer;\n  transition: var(--transition-smooth);\n}\n\n.navbar-brand:hover {\n  transform: scale(1.05);\n}\n\n.logo-text {\n  letter-spacing: 2px;\n}\n\n.navbar-menu {\n  display: flex;\n  gap: 40px;\n  align-items: center;\n}\n\n.nav-link {\n  color: var(--text-primary);\n  text-decoration: none;\n  font-weight: 500;\n  position: relative;\n  transition: var(--transition-smooth);\n  padding: 5px 0;\n}\n\n.nav-link::after {\n  content: '';\n  position: absolute;\n  bottom: -5px;\n  left: 0;\n  width: 0;\n  height: 2px;\n  background: var(--gradient-primary);\n  transition: width 0.3s ease;\n}\n\n.nav-link:hover::after {\n  width: 100%;\n}\n\n.nav-link:hover {\n  color: var(--primary-color);\n}\n\n.navbar-actions {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n}\n\n.language-selector {\n  position: relative;\n}\n\n.lang-button {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 16px;\n  background: rgba(255, 255, 255, 0.1);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  border-radius: 25px;\n  color: var(--text-primary);\n  cursor: pointer;\n  transition: var(--transition-smooth);\n}\n\n.lang-button:hover {\n  background: rgba(255, 255, 255, 0.15);\n  border-color: var(--primary-color);\n}\n\n.current-lang {\n  font-size: 1.2rem;\n}\n\n.lang-dropdown {\n  position: absolute;\n  top: calc(100% + 10px);\n  right: 0;\n  background: var(--dark-secondary);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 15px;\n  overflow: hidden;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.5);\n  animation: fadeIn 0.3s ease;\n}\n\n.lang-option {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 12px 20px;\n  background: transparent;\n  border: none;\n  color: var(--text-primary);\n  cursor: pointer;\n  width: 100%;\n  text-align: left;\n  transition: var(--transition-smooth);\n}\n\n.lang-option:hover {\n  background: rgba(255, 255, 255, 0.1);\n}\n\n.lang-option.active {\n  background: var(--gradient-primary);\n  color: var(--dark-bg);\n}\n\n.lang-flag {\n  font-size: 1.2rem;\n}\n\n.menu-toggle {\n  display: none;\n  background: transparent;\n  border: none;\n  color: var(--text-primary);\n  cursor: pointer;\n  padding: 8px;\n  transition: var(--transition-smooth);\n}\n\n.menu-toggle:hover {\n  color: var(--primary-color);\n}\n\n/* Mobile Styles */\n@media (max-width: 768px) {\n  .navbar-menu {\n    position: fixed;\n    top: 0;\n    right: -100%;\n    width: 80%;\n    max-width: 300px;\n    height: 100vh;\n    background: var(--dark-secondary);\n    flex-direction: column;\n    justify-content: center;\n    gap: 30px;\n    transition: right 0.3s ease;\n    box-shadow: -5px 0 20px rgba(0, 0, 0, 0.5);\n  }\n\n  .navbar-menu.active {\n    right: 0;\n  }\n\n  .menu-toggle {\n    display: block;\n  }\n\n  .nav-link {\n    font-size: 1.2rem;\n  }\n\n  .navbar-brand {\n    font-size: 1.2rem;\n  }\n\n  .lang-dropdown {\n    right: -50px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
